function isMouseEvent(event) {
  return event.pageY !== undefined;
}

export { isMouseEvent as default };
